"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _grid = require("@alicd/next/lib/grid");

var _grid2 = _interopRequireDefault(_grid);

var _Item$propTypes;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;


var funcId = function funcId(x) {
    return x;
};

var classNameAlign = function classNameAlign(align) {
    return "cn-detail-" + align;
};

var ComponentInnerTop = function ComponentInnerTop(props) {
    var children = props.children,
        rest = (0, _objectWithoutProperties3.default)(props, ["children"]);


    return _react2.default.createElement(
        "div",
        rest,
        _react2.default.createElement(
            Row,
            { type: "no-padding" },
            children
        )
    );
};

var ComponentOuterTop = function ComponentOuterTop(props) {
    var children = props.children,
        rest = (0, _objectWithoutProperties3.default)(props, ["children"]);


    return _react2.default.createElement(
        "div",
        rest,
        _react2.default.createElement(
            "div",
            { className: "cn-detail-pad" },
            children
        )
    );
};

var Item = function (_React$Component) {
    (0, _inherits3.default)(Item, _React$Component);

    function Item(props) {
        (0, _classCallCheck3.default)(this, Item);
        return (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));
    }

    (0, _createClass3.default)(Item, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                label = _props.label,
                labelCol = _props.labelCol,
                wrapperCol = _props.wrapperCol,
                labelAlign = _props.labelAlign,
                labelTextAlign = _props.labelTextAlign,
                wrapperTextAlign = _props.wrapperTextAlign,
                dataSource = _props.dataSource,
                dataIndex = _props.dataIndex,
                render = _props.render,
                placeholder = _props.placeholder,
                children = _props.children,
                rest = (0, _objectWithoutProperties3.default)(_props, ["className", "label", "labelCol", "wrapperCol", "labelAlign", "labelTextAlign", "wrapperTextAlign", "dataSource", "dataIndex", "render", "placeholder", "children"]);


            if (placeholder) {
                return _react2.default.createElement("span", (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-detail-item cn-detail-placeholder", "cn-detail-item-" + labelAlign, className)
                }, rest));
            }

            var ComponentInner = labelAlign == "left" ? Col : "div";
            var ComponentOuter = labelAlign == "left" ? ComponentInnerTop : ComponentOuterTop;

            var labelProps = labelAlign == "left" ? labelCol : {};
            var wrapperProps = labelAlign == "left" ? wrapperCol : {};

            var labelElement = _react2.default.createElement(
                ComponentInner,
                (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-detail-label", classNameAlign(labelTextAlign))
                }, labelProps),
                label
            );

            var content = void 0;
            if (dataIndex && dataSource) {
                content = (0, _util.getDataByPath)(dataSource, dataIndex);
            } else {
                content = children;
            }
            content = render(content, dataIndex, dataSource);
            var contentElement = _react2.default.createElement(
                ComponentInner,
                (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-detail-value", classNameAlign(wrapperTextAlign))
                }, wrapperProps),
                content || "-"
            );

            return _react2.default.createElement(
                ComponentOuter,
                (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-detail-item cn-detail-item-solid", "cn-detail-item-" + labelAlign, className)
                }, rest),
                labelElement,
                contentElement
            );
        }
    }]);
    return Item;
}(_react2.default.Component);

Item.propTypes = (_Item$propTypes = {
    className: _propTypes2.default.string,
    dataSource: _propTypes2.default.object,
    label: _propTypes2.default.node,
    labelCol: _propTypes2.default.object,
    wrapperCol: _propTypes2.default.object,
    labelAlign: _propTypes2.default.oneOf(["left", "top"]),
    labelTextAlign: _propTypes2.default.oneOf(["left", "center", "right"]),
    wrapperTextAlign: _propTypes2.default.oneOf(["left", "center", "right"]),
    dataIndex: _propTypes2.default.string,
    render: _propTypes2.default.func
}, (0, _defineProperty3.default)(_Item$propTypes, "dataSource", _propTypes2.default.object), (0, _defineProperty3.default)(_Item$propTypes, "placeholder", _propTypes2.default.bool), _Item$propTypes);
Item.defaultProps = {
    placeholder: false,
    render: funcId
};
exports.default = Item;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-detail@0.0.6@@alicd/crui-detail/lib/Item.js
// module id = 153
// module chunks = 0